import httpService from "./httpService";

export default {
  // Must run before the Auth0 token cache is cleared; a failure is ignored so the Auth0 logout always follows
  logout: async () => httpService.postWithNoReauthentication("/auth/logout").catch(() => undefined),
};
